import { render, staticRenderFns } from "./SlimDatePicker.vue?vue&type=template&id=792b8fbc"
import script from "./SlimDatePicker.vue?vue&type=script&lang=js"
export * from "./SlimDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports